export default __webpack_public_path__ + "static/media/Bitmap_1.0fcb348f.jpg";